import type { FormControl } from '@angular/forms';
import type {
  Counterparty,
  CounterpartySubdivision,
  InstallZone,
} from '@core/types';
import type { RequestInstallerAssignmentInstaller } from '@outkeep/shared';

export enum RequestInstallerAssignmentField {
  ContractorCounterparty = 'contractorCounterparty',
  ContractorSubdivision = 'contractorSubdivision',
  InstallZone = 'installZone',
  Installer = 'installer',
}

export type RequestInstallerAssignmentFormControls = {
  [RequestInstallerAssignmentField.ContractorCounterparty]: FormControl<Counterparty | null>;
  [RequestInstallerAssignmentField.ContractorSubdivision]: FormControl<CounterpartySubdivision | null>;
  [RequestInstallerAssignmentField.InstallZone]: FormControl<InstallZone | null>;
  // Персона установщика: бэкенд ждёт installerId = id персоны
  [RequestInstallerAssignmentField.Installer]: FormControl<RequestInstallerAssignmentInstaller | null>;
};

export type RequestInstallerAssignmentInitialValue = {
  contractorCounterparty: Counterparty | null;
  contractorSubdivision: CounterpartySubdivision | null;
  installZone: InstallZone | null;
  installer: RequestInstallerAssignmentInstaller | null;
};
